export const SEND_PLATFORM_INQUIRY = 'send-platform-inquiry';
const sendPlatformInquiry = ({ firstName, lastName, email, company, phone, comment }) => ({
  type: SEND_PLATFORM_INQUIRY,
  payload: { firstName, lastName, email, company, phone, comment },
});
export default sendPlatformInquiry;
